import { LoaderFunction, useLoaderData, useLocation, useNavigate } from "react-router-dom"
import { AviTracerApi } from "../../../avitracerApi";
import { useAppDispatch } from "../../../store/hooks";
import FlightPlan from "../../../models/flightPlan";
import { createFlightPlan, deleteFlightPlan, editFlightPlan } from "../../../store/flightPlansSlice";
import EntityDetailsPage from "../../../components/EntityDetails/EntityDetailsPage";
import { EntityDisplayInfo } from "../../../components/EntityDetails/EntityDetailsDisplayInfo";
import { fetchSwitchingTeamIfNeeded } from "../../../utils/fetchSwitchingTeam";

export const flightPlanLoader: LoaderFunction = async (params) => {
    return fetchSwitchingTeamIfNeeded((orgId) => AviTracerApi.getFlightPlanWithId(params.params["fplId"]!, orgId));
}

function FlightPlanDetailsPage() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate();
  
    const location = useLocation()
    const quickAddFlightPlan = location.state?.flightPlan as FlightPlan
    

    const loadedFlightPlan = useLoaderData() as FlightPlan;

    const baseFlightPlan: FlightPlan = loadedFlightPlan ?? quickAddFlightPlan ?? {};

    //IFR Details are COPIED from the linked aircraft rather than silently merged at filing time: the
    //form shows the aircraft's real values, and the user can change any of them for this plan alone.
    //Only fills what the plan does not already carry, so a previously edited value is never overwritten.
    const flightPlan: FlightPlan = baseFlightPlan.aircraft
        ? {
              ...baseFlightPlan,
              pbn: baseFlightPlan.pbn ?? baseFlightPlan.aircraft.pbnCapabilities,
              field18Nav: baseFlightPlan.field18Nav ?? baseFlightPlan.aircraft.field18Nav,
              field18Com: baseFlightPlan.field18Com ?? baseFlightPlan.aircraft.field18Com,
              field18Dat: baseFlightPlan.field18Dat ?? baseFlightPlan.aircraft.field18Dat,
              ifrFuelPerHour: baseFlightPlan.ifrFuelPerHour ?? baseFlightPlan.aircraft.fuelPerHour,
              ifrMaxMass:
                  baseFlightPlan.ifrMaxMass ?? baseFlightPlan.aircraft.wb?.maxMass ?? baseFlightPlan.aircraft.mtow,
          }
        : baseFlightPlan;

    const handleSaveFlightPlan = async (flightPlan: FlightPlan) => {
        if (!flightPlan.id) {
            return await dispatch(createFlightPlan(flightPlan)).unwrap()
        }else{
            return await dispatch(editFlightPlan(flightPlan)).unwrap()
        }
    };

    const handleDeleteFlightPlan = async (flightPlan: FlightPlan) => {
        await dispatch(deleteFlightPlan(flightPlan)).unwrap()
    };

    const goBack = () => {
        navigate("/fpls")
    }

    return (
        <EntityDetailsPage
            entity={flightPlan}
            handleClose={goBack}
            displayInfo={EntityDisplayInfo.FlightPlan(flightPlan.aircraft?.fuelUnit)}
            dispatchSaveEntity={handleSaveFlightPlan}
            dispatchDeleteEntity={handleDeleteFlightPlan}
        />
    )
}

export default FlightPlanDetailsPage